module.exports = __webpack_public_path__ + "static/media/gp-sp2025_768.51d00ad3.png";